import { Button, ButtonsGroup, Modal, ModalProps, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

// dedicated modal (not `ModalConfirmation`) because the primary/secondary mapping is
// inverted vs. the template: the primary right-hand action closes the dialog without
// applying any change (safe-by-default), while the secondary left-hand action triggers
// the validation. Composing the raw `Modal` primitives keeps the code intent-clear.
interface ReviewEntriesBulkValidateConfirmationModalProps extends Omit<ModalProps, 'closable' | 'children'> {
  clarificationCount: number
  onReviewAndClarify: () => void
  onValidateNow: () => void
}

export const ReviewEntriesBulkValidateConfirmationModal = ({
  clarificationCount,
  id,
  onReviewAndClarify,
  onValidateNow,
  ...rest
}: ReviewEntriesBulkValidateConfirmationModalProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Modal id={id} size="s" closable {...rest}>
      <Modal.Header title={t('review_entries.bulk_validate.confirm.title', { count: clarificationCount })} />
      <Modal.Body>
        <Text colorVariant="secondary">{t('review_entries.bulk_validate.confirm.body')}</Text>
      </Modal.Body>
      <Modal.Footer>
        <ButtonsGroup>
          <Button onClick={onValidateNow} variant="text">
            {t('review_entries.bulk_validate.confirm.validate_now')}
          </Button>
          <Button onClick={onReviewAndClarify}>{t('review_entries.bulk_validate.confirm.review')}</Button>
        </ButtonsGroup>
      </Modal.Footer>
    </Modal>
  )
}
